<div class="tw:w-full tw:px-4">
  @for (answer of answers; track answer) {
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
      <div class="tw:flex-1 tw:px-[15px]">
        <label>{{answer.body}}</label>
      </div>
    </div>
  }
</div>
